<template>
<div class="cambook-header flex justify-between items-center">
  <div class="cambook-logo">
    <img :src="logo" alt="CamBook" @click="toHome"/>
  </div>
  <div class="cambook-search">
    <el-input class="cambook-search__input" v-model="searchValue"
              placeholder="Search in bookshelf" clearable @keydown.enter="submitSearch">
      <template #suffix>
        <el-icon class="el-input__icon cursor-pointer" size="18" @click="submitSearch"><search /></el-icon>
      </template>
    </el-input>
  </div>
</div>
</template>

<script>
const logo = '/marketing/cambook-logo-new.png'
import { Search } from '@element-plus/icons-vue'
export default {
  name: 'LayoutHeader',
  components: {
    Search,
  },
  data() {
    return {
      logo,
      searchValue: '',
    }
  },
  methods: {
    submitSearch() {
      if (this.searchValue.trim()) {
        this.$router.push({
          path: '/search',
          query: {
            keyword: this.searchValue.trim(),
          },
        })
      } else if (this.$route.path === '/search') {
        this.$router.push({
          path: '/home',
        })
      }
    },
    toHome() {
      this.searchValue = ''
      this.$router.push({
        path: '/home',
      })
    },
  },
}
</script>

<style scoped lang="scss">
.cambook-header{
  position: fixed;
  top:0;
  left: 0;
  right: 0;
  background: #ffffff;
  z-index: 2;
}
.cambook-logo{
  width: 196px;
  height: 40px;
  margin: 18px 0;
  flex: 0 0 200px;
  img{
    margin-top: -15px;
    max-width: 120%;
    cursor: pointer;
  }
}
.cambook-search{
  flex:1;
  padding-left: 120px;
  @media screen and (max-width: 1200px) {
    padding: 0  40px;
  }
}
:deep(.cambook-search__input){
  width: 100%;
  border:none;
  --el-input-border-radius:1000px;
  --el-input-bg-color:#f8f8f8;
  --el-input-border-color: #f8f8f8;
  --el-input-focus-border-color:#f8f8f8;
  font-size: 12px;
}
:deep(.el-input__wrapper){
  padding: 1px 26px;
}

</style>
